import React from 'react'
import { FaIcon, faNoteSolid } from '@/lib/fa'
import { TextAreaField } from '@/ui/form/controls/TextAreaField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useAlertForm } from '../AlertFormContext'

const AlertInfo = () => {
  const { t } = useLocalize()
  const { text, setText } = useAlertForm()

  return (
    <div className="tw-flex tw-gap-2">
      <div className="tw-jusit tw-flex tw-max-w-[200px] tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faNoteSolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
        {t('addAlertPopup.information')}
        </p>
      </div>

      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextAreaField
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={3}
          placeholder={t('addAlertPopup.information-placeholder')}
        />
      </div>
    </div>
  )
}

export default AlertInfo
